import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Container, Grid } from '@mui/material'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import PageMetaData from '@v4/utils/data/PageMetaData'
import EditableContainer from '@v4/components/common/EditableContainer'
import Item from './components/Item'
import { useContent4 } from './Content4.hooks'

const Content4 = props => {
	const [
		{
			classes,
			maxWidth,
			text,
			textConfig,
			columnsNumber,
			items,
			textEditable,
			verticalAlignment,
			textKey,
			alignment,
		},
		{ handleTextClick, handleTextChange },
	] = useContent4(props)

	return (
		<Container maxWidth={maxWidth} className="content4">
			<Grid container justifyContent="center" width="100%" className="content4-content">
				<EditableContainer
					className={classes.editableContainer}
					visible={!!text}
					fieldConfig={textConfig}
					onAdd={handleTextChange}
					editable={textEditable}
					wrapper={({ children }) => (
						<Grid
							size={{
								lg: 8,
								md: 8,
								sm: 12,
								xs: 12,
							}}
						>
							{children}
						</Grid>
					)}
				>
					<Box>
						<EditableHTML
							key={textKey}
							className={clsx(classes.text, 'content4-text-block')}
							html={text}
							onClick={handleTextClick}
							editable={textEditable}
							onChange={handleTextChange}
						/>
					</Box>
				</EditableContainer>
				<Grid container justifyContent={alignment} width="100%" spacing={5} className="content4-items">
					{_.map(items, (key, index) => (
						<Item
							key={key}
							group="items"
							itemKey={key}
							index={index}
							columnsNumber={columnsNumber}
							verticalAlignment={verticalAlignment}
						/>
					))}
				</Grid>
			</Grid>
		</Container>
	)
}

Content4.propTypes = {
	metaData: PropTypes.shape({
		text: PropTypes.instanceOf(PageMetaData),
		columns: PropTypes.instanceOf(PageMetaData),
		verticalAlignment: PropTypes.instanceOf(PageMetaData),
		mobileAlignment: PropTypes.instanceOf(PageMetaData),
		overrideXsMargins: PropTypes.instanceOf(PageMetaData),
		xsMarginTop: PropTypes.instanceOf(PageMetaData),
		xsMarginBottom: PropTypes.instanceOf(PageMetaData),
	}).isRequired,
}

export default memo(Content4)
